module.exports = __webpack_public_path__ + "static/home-alive-calling.3ef12525.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home-alive-calling.png
// module id = 481
// module chunks = 35783957827783